import { render, staticRenderFns } from "./InstagramAndPress.vue?vue&type=template&id=6997c79b&scoped=true&"
import script from "./InstagramAndPress.vue?vue&type=script&lang=js&"
export * from "./InstagramAndPress.vue?vue&type=script&lang=js&"
import style0 from "./InstagramAndPress.vue?vue&type=style&index=0&id=6997c79b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997c79b",
  null
  
)

export default component.exports